import React from 'react'
import styled from '@emotion/styled'
import { IconProps } from '../../models/IconProps'
const BaseComponent = ({ size = 24, tabIndex = -1, focusable = false, ...props }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      tabIndex={tabIndex}
      focusable={focusable}
      fill="currentColor"
      {...props}
    >
      <defs>
        <clipPath id="bojq4fc74a">
          <path d="M1440 0v1175H0V0h1440z" />
        </clipPath>
        <clipPath id="4n4pd6avhb">
          <path d="M9 0c.21 0 .41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18-.21 0-.41-.06-.57-.18l-7.9-4.44A.991.991 0 0 1 0 14.5v-9c0-.38.21-.71.53-.88L8.43.18C8.59.06 8.79 0 9 0zM2 7.21v6.7l6 3.38v-6.71L2 7.21zm14 0-6 3.37v6.71l6-3.38v-6.7z" />
        </clipPath>
      </defs>
      <g clipPath="url(#bojq4fc74a)" transform="translate(-658 -188)">
        <g clipPath="url(#4n4pd6avhb)" transform="translate(661 190)">
          <path fill="currentColor" d="M0 0h18v20H0V0z" />
        </g>
      </g>
    </svg>
  )
}
export default styled(BaseComponent)`
  outline: none;
`
